import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const DeliveryRunsListPage = lazy(
  () => import('~/features/deliveries/pages/delivery-runs-list-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/deliveries/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <DeliveryRunsListPage />
    </Suspense>
  ),
});
